import { includes, toLower } from 'lodash'

const stringIncludes = (string, value) =>
  includes(toLower(string), toLower(value))

export default stringIncludes
